'use strict';

angular.module('amexReconciliationApp')
  .service('PurchaseOrderThirdPartyDataRepository',
    function PurchaseOrderThirdPartyDataRepository($resource, $http, $q) {
      var self = this;
      var purchaseOrderThirdPartyDataResource =
        $resource('/api/v1/transactions/:transactionId/purchaseOrderThirdPartyData');

      self.getPurchaseOrderThirdPartyData = function getPurchaseOrderThirdPartyData(transactionId) {
        return purchaseOrderThirdPartyDataResource
          .get({transactionId: transactionId})
          .$promise
          .then(function (response) {
            return response.toJSON();
          })
          .catch(function (response) {
            if (response.status === 404) {
              return $q.when({});
            }

            return response;
          });
      };

      var poByTransactionAndBillingCycleUrl =
        '/api/v1/purchaseOrderByTransactionAndBillingCycle';

      self.getPOByTransactionAndBillingCycle = function getPOByTransactionAndBillingCycle(transactionId, billingCycle, hideClosed) {

        var dateRegEx = new RegExp(/^\d{4}\-\d{1,2}\-\d{1,2}$/);
        var startDateTime = dateRegEx.test(billingCycle.startDate) ? Date.parse(billingCycle.startDate) : billingCycle.startDate;
        var endDateTime = dateRegEx.test(billingCycle.endDate) ? Date.parse(billingCycle.endDate) : billingCycle.endDate;

        var poParams = {
          transactionId: transactionId,
          endDate: endDateTime,
          startDate: startDateTime,
          filter: hideClosed ? 'ONLY_OPEN' : 'ALL'
        };

        return $http({
          method: 'GET',
          url: poByTransactionAndBillingCycleUrl,
          params: poParams
        }).then(function (response) {
          return response.data;
        });
      };
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/PurchaseOrderThirdPartyDataRepository.js
// module id = 617
// module chunks = 0